import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ProductProvider } from "../contexts/ProductsDataContexts";
import { Suspense, lazy } from "react";
import Loader from "../components/Loader/Loader";
import { CartContextProvider } from "../contexts/cartContext.js";
import { Toaster } from "react-hot-toast";
import { OrderContextProvider } from "../contexts/ordersContext";
import Orders from "../Pages/Orders/Orders";
import DashBoard from "../Pages/DashBoard/DashBoard";
const Home = lazy(() => import("../Pages/Home/Home.jsx"));
const Shop = lazy(() => import("../Pages/Shop/Shop.jsx"));
const Blog = lazy(() => import("../Pages/Blog/Blog"));
const About = lazy(() => import("../Pages/About/About"));
const ProductDetails = lazy(() =>
  import("../Pages/ProductDetails/ProductDetails")
);
const CreateOrder = lazy(() => import("../Pages/CreateOrder/CreateOrder"));
const Contact = lazy(() => import("../Pages/Contact/Contact"));
const Cart = lazy(() => import("../Pages/Cart/Cart"));
const PageNotFound = lazy(() => import("../Pages/PageNotFound"));

function App() {
  return (
    <OrderContextProvider>
      <ProductProvider>
        <CartContextProvider>
          <BrowserRouter>
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route
                  path="/productDetails/:id"
                  element={<ProductDetails />}
                />
                <Route path="/blog" element={<Blog />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/createOrder" element={<CreateOrder />} />
                <Route path="/dashboard" element={<DashBoard />}>
                  <Route index element={<Orders />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="user" element={<PageNotFound />} />
                  <Route path="settings" element={<PageNotFound />} />
                </Route>
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster
            position="top-center"
            containerStyle={{
              margin: "8px",
            }}
            gutter={12}
            toastOptions={{
              duration: 5000,
              style: {
                background: "#fff",
                color: "#363636",
                fontSize: "16px",
                padding: "2px",
                textAlign: "center",
              },

              success: {
                duration: 3000,
                icon: "😊",
                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
              error: {
                duration: 4000,
                icon: "😡",

                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
            }}
          />
        </CartContextProvider>
      </ProductProvider>
    </OrderContextProvider>
  );
}

export default App;
